import Swiper, { Navigation, Scrollbar } from 'swiper/core';
Swiper.use([Navigation, Scrollbar]);

export default class SliderSectionSlider {
    constructor(elm, args) {

        let options = {
            spaceBetween: 30,
            allowTouchMove: true,
            slidesPerView: 2,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                snapOnRelease: true,
            },
        };

        let swiper = new Swiper(elm, options);
    }

    update() {
        this.swiper.update();
    }

    destroy() {
        this.swiper.destroy();
    }

}

